import { render, staticRenderFns } from "./LyricsContainer.vue?vue&type=template&id=0f807315&scoped=true"
import script from "./LyricsContainer.vue?vue&type=script&lang=js"
export * from "./LyricsContainer.vue?vue&type=script&lang=js"
import style0 from "./LyricsContainer.vue?vue&type=style&index=0&id=0f807315&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f807315",
  null
  
)

export default component.exports